<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-flex md12>
        <h1 class="text-xs-center">Not Found</h1>
      </v-flex>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  props: {}
};
</script>